<template>
  <div id="app" class="global_wrapper ly-global_wrapper">
    <Header></Header>
    <div id="humberger_button_generator">
      <main class="contents_area ly-contents_area">
        <Console @css="pass_to_code"></Console>
        <!-- responsive AdSense -->
        <ins
          class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-2882260854579000"
          data-ad-slot="8080804629"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
        <Code :css="css"></Code>
        <Footer></Footer>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "./components/Header.vue";
import Console from "./components/Console.vue";
import Code from "./components/Code.vue";
import Footer from "./components/Footer.vue";

export default Vue.extend({
  name: "app",
  components: {
    Header,
    Console,
    Code,
    Footer
  },
  data() {
    return {
      css: {
        button_width: 42,
        button_height: 26,
        bar_line_width: 2,
        active_line_length: 36.77,
        left: 0,
        top: 0,
        bottom: 0,
        color: "2274a5",
        radian: 0.7853981633974483
      }
    };
  },
  mounted() {
    (function(d) {
      var config = {
          kitId: "udv8jul",
          scriptTimeout: 3000,
          async: true
        },
        h = d.documentElement,
        t = setTimeout(function() {
          h.className =
            h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
        }, config.scriptTimeout),
        tk = d.createElement("script"),
        f = false,
        s = d.getElementsByTagName("script")[0],
        a;
      h.className += " wf-loading";
      tk.src = "https://use.typekit.net/" + config.kitId + ".js";
      tk.async = true;
      tk.onload = tk.onreadystatechange = function() {
        a = this.readyState;
        if (f || (a && a != "complete" && a != "loaded")) return;
        f = true;
        clearTimeout(t);
        try {
          Typekit.load(config);
        } catch (e) {
          console.warn(e);
        }
      };
      s.parentNode.insertBefore(tk, s);
    })(document);

    (window.adsbygoogle = window.adsbygoogle || []).push({});
  },
  methods: {
    pass_to_code(css) {
      this.css = css;
    }
  }
});
</script>

<style lang="scss">
@import "./assets/style/colors";
@import "./assets/style/normalize.css";
@import "./assets/style/layout.scss";
@import "./assets/style/general.scss";
</style>
